// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=js"
// @generated from file vitesse/v1/model.proto (package vitesse.v1, syntax proto3)
/* eslint-disable */
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_vitesse_v1_entitlements } from "./entitlements_pb.js";
import { file_vitesse_v1_common } from "./common_pb.js";
import { file_vitesse_v1_integrations } from "./integrations_pb.js";
import { file_vitesse_v1_log } from "./log_pb.js";
/**
 * Describes the file vitesse/v1/model.proto.
 */
export const file_vitesse_v1_model = /*@__PURE__*/ fileDesc("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", [file_vitesse_v1_entitlements, file_vitesse_v1_common, file_vitesse_v1_integrations, file_vitesse_v1_log]);
/**
 * Describes the message vitesse.v1.ModelRunnerDescriptor.
 * Use `create(ModelRunnerDescriptorSchema)` to create a new message.
 */
export const ModelRunnerDescriptorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 0);
/**
 * Describes the message vitesse.v1.ModelRunnerStats.
 * Use `create(ModelRunnerStatsSchema)` to create a new message.
 */
export const ModelRunnerStatsSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 1);
/**
 * Describes the message vitesse.v1.ModelSummary.
 * Use `create(ModelSummarySchema)` to create a new message.
 */
export const ModelSummarySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 2);
/**
 * Describes the message vitesse.v1.ModelDescriptor.
 * Use `create(ModelDescriptorSchema)` to create a new message.
 */
export const ModelDescriptorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 3);
/**
 * Describes the message vitesse.v1.ModelNotify.
 * Use `create(ModelNotifySchema)` to create a new message.
 */
export const ModelNotifySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 4);
/**
 * Describes the message vitesse.v1.ModelTemplate.
 * Use `create(ModelTemplateSchema)` to create a new message.
 */
export const ModelTemplateSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 5);
/**
 * Describes the message vitesse.v1.ModelChild.
 * Use `create(ModelChildSchema)` to create a new message.
 */
export const ModelChildSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 6);
/**
 * Describes the message vitesse.v1.ModelBinding.
 * Use `create(ModelBindingSchema)` to create a new message.
 */
export const ModelBindingSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 7);
/**
 * Describes the message vitesse.v1.ModelPlcOutput.
 * Use `create(ModelPlcOutputSchema)` to create a new message.
 */
export const ModelPlcOutputSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 8);
/**
 * Describes the message vitesse.v1.ModelInterface.
 * Use `create(ModelInterfaceSchema)` to create a new message.
 */
export const ModelInterfaceSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 9);
/**
 * Describes the message vitesse.v1.ModelInput.
 * Use `create(ModelInputSchema)` to create a new message.
 */
export const ModelInputSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 10);
/**
 * KIND_ANY (the zero) is a DELIBERATE meaningful default — "accepts any kind"
 * (a symbol OR a model variable). Not renamed to *_UNSPECIFIED because the
 * CI breaking gate is WIRE_JSON: an enum-value rename changes the JSON name
 * and is (correctly) rejected. ENUM_ZERO_VALUE_SUFFIX is excepted in buf.yaml.
 *
 * @generated from enum vitesse.v1.ModelInput.Kind
 */
export var ModelInput_Kind;
(function (ModelInput_Kind) {
    /**
     * @generated from enum value: KIND_ANY = 0;
     */
    ModelInput_Kind[ModelInput_Kind["ANY"] = 0] = "ANY";
    /**
     * @generated from enum value: KIND_SYMBOL = 1;
     */
    ModelInput_Kind[ModelInput_Kind["SYMBOL"] = 1] = "SYMBOL";
    /**
     * @generated from enum value: KIND_MODEL_VAR = 2;
     */
    ModelInput_Kind[ModelInput_Kind["MODEL_VAR"] = 2] = "MODEL_VAR";
})(ModelInput_Kind || (ModelInput_Kind = {}));
/**
 * Describes the enum vitesse.v1.ModelInput.Kind.
 */
export const ModelInput_KindSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_model, 10, 0);
/**
 * Describes the message vitesse.v1.ModelOutput.
 * Use `create(ModelOutputSchema)` to create a new message.
 */
export const ModelOutputSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 11);
/**
 * Describes the message vitesse.v1.ModelCommand.
 * Use `create(ModelCommandSchema)` to create a new message.
 */
export const ModelCommandSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 12);
/**
 * Describes the message vitesse.v1.SamplingSpec.
 * Use `create(SamplingSpecSchema)` to create a new message.
 */
export const SamplingSpecSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 13);
/**
 * Describes the message vitesse.v1.ModelRuntime.
 * Use `create(ModelRuntimeSchema)` to create a new message.
 */
export const ModelRuntimeSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 14);
/**
 * Describes the message vitesse.v1.ModelMachineState.
 * Use `create(ModelMachineStateSchema)` to create a new message.
 */
export const ModelMachineStateSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 15);
/**
 * Describes the message vitesse.v1.ModelVariableDescriptor.
 * Use `create(ModelVariableDescriptorSchema)` to create a new message.
 */
export const ModelVariableDescriptorSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 16);
/**
 * Describes the message vitesse.v1.ModelVariableValue.
 * Use `create(ModelVariableValueSchema)` to create a new message.
 */
export const ModelVariableValueSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 17);
/**
 * Describes the message vitesse.v1.StateTransitionEvent.
 * Use `create(StateTransitionEventSchema)` to create a new message.
 */
export const StateTransitionEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 18);
/**
 * Describes the message vitesse.v1.ExecuteModelCommandRequest.
 * Use `create(ExecuteModelCommandRequestSchema)` to create a new message.
 */
export const ExecuteModelCommandRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 19);
/**
 * Describes the message vitesse.v1.ExecuteModelCommandReply.
 * Use `create(ExecuteModelCommandReplySchema)` to create a new message.
 */
export const ExecuteModelCommandReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 20);
/**
 * Describes the message vitesse.v1.SetModelVariableRequest.
 * Use `create(SetModelVariableRequestSchema)` to create a new message.
 */
export const SetModelVariableRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 21);
/**
 * Describes the message vitesse.v1.SetModelVariableReply.
 * Use `create(SetModelVariableReplySchema)` to create a new message.
 */
export const SetModelVariableReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 22);
/**
 * Describes the message vitesse.v1.DeleteModelRequest.
 * Use `create(DeleteModelRequestSchema)` to create a new message.
 */
export const DeleteModelRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 23);
/**
 * Describes the message vitesse.v1.DeleteModelReply.
 * Use `create(DeleteModelReplySchema)` to create a new message.
 */
export const DeleteModelReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 24);
/**
 * Describes the message vitesse.v1.UpdateModelRequest.
 * Use `create(UpdateModelRequestSchema)` to create a new message.
 */
export const UpdateModelRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 25);
/**
 * Describes the message vitesse.v1.UpdateModelReply.
 * Use `create(UpdateModelReplySchema)` to create a new message.
 */
export const UpdateModelReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 26);
/**
 * Describes the message vitesse.v1.ModelsExecuteCommandRequest.
 * Use `create(ModelsExecuteCommandRequestSchema)` to create a new message.
 */
export const ModelsExecuteCommandRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 27);
/**
 * Describes the message vitesse.v1.ModelsSetVariableRequest.
 * Use `create(ModelsSetVariableRequestSchema)` to create a new message.
 */
export const ModelsSetVariableRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 28);
/**
 * Describes the message vitesse.v1.ModelsDeleteRequest.
 * Use `create(ModelsDeleteRequestSchema)` to create a new message.
 */
export const ModelsDeleteRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 29);
/**
 * Describes the message vitesse.v1.ModelsUpdateRequest.
 * Use `create(ModelsUpdateRequestSchema)` to create a new message.
 */
export const ModelsUpdateRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 30);
/**
 * Describes the message vitesse.v1.ModelsCreateRequest.
 * Use `create(ModelsCreateRequestSchema)` to create a new message.
 */
export const ModelsCreateRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 31);
/**
 * Describes the message vitesse.v1.ModelsCreateReply.
 * Use `create(ModelsCreateReplySchema)` to create a new message.
 */
export const ModelsCreateReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 32);
/**
 * Describes the message vitesse.v1.ModelsSubscribeRequest.
 * Use `create(ModelsSubscribeRequestSchema)` to create a new message.
 */
export const ModelsSubscribeRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 33);
/**
 * Describes the message vitesse.v1.ModelEvent.
 * Use `create(ModelEventSchema)` to create a new message.
 */
export const ModelEventSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 34);
/**
 * @generated from enum vitesse.v1.ModelEvent.Op
 */
export var ModelEvent_Op;
(function (ModelEvent_Op) {
    /**
     * @generated from enum value: OP_UNSPECIFIED = 0;
     */
    ModelEvent_Op[ModelEvent_Op["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * descriptor / runtime present below
     *
     * @generated from enum value: OP_PUT = 1;
     */
    ModelEvent_Op[ModelEvent_Op["PUT"] = 1] = "PUT";
    /**
     * model removed (descriptor purged); both unset
     *
     * @generated from enum value: OP_DELETE = 2;
     */
    ModelEvent_Op[ModelEvent_Op["DELETE"] = 2] = "DELETE";
})(ModelEvent_Op || (ModelEvent_Op = {}));
/**
 * Describes the enum vitesse.v1.ModelEvent.Op.
 */
export const ModelEvent_OpSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_model, 34, 0);
/**
 * Describes the message vitesse.v1.GetModelSourceRequest.
 * Use `create(GetModelSourceRequestSchema)` to create a new message.
 */
export const GetModelSourceRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 35);
/**
 * Describes the message vitesse.v1.GetModelSourceReply.
 * Use `create(GetModelSourceReplySchema)` to create a new message.
 */
export const GetModelSourceReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 36);
/**
 * Describes the message vitesse.v1.FetchModelSourceRequest.
 * Use `create(FetchModelSourceRequestSchema)` to create a new message.
 */
export const FetchModelSourceRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 37);
/**
 * Describes the message vitesse.v1.FetchModelSourceReply.
 * Use `create(FetchModelSourceReplySchema)` to create a new message.
 */
export const FetchModelSourceReplySchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 38);
/**
 * Describes the message vitesse.v1.ModelsStateTransitionRequest.
 * Use `create(ModelsStateTransitionRequestSchema)` to create a new message.
 */
export const ModelsStateTransitionRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 39);
/**
 * Describes the message vitesse.v1.ModelsLogsRequest.
 * Use `create(ModelsLogsRequestSchema)` to create a new message.
 */
export const ModelsLogsRequestSchema = /*@__PURE__*/ messageDesc(file_vitesse_v1_model, 40);
/**
 * The rules that a model keeps (ModelDescriptor.profile).
 *
 * @generated from enum vitesse.v1.ModelProfile
 */
export var ModelProfile;
(function (ModelProfile) {
    /**
     * The rules of every model.
     *
     * @generated from enum value: MODEL_PROFILE_GENERAL = 0;
     */
    ModelProfile[ModelProfile["GENERAL"] = 0] = "GENERAL";
    /**
     * The rules of the hard real-time profile too: each slot holds 1 value of
     * 1 kind, no code makes a new value, each loop and each timer has a limit
     * that the text fixes.
     *
     * @generated from enum value: MODEL_PROFILE_HARD = 1;
     */
    ModelProfile[ModelProfile["HARD"] = 1] = "HARD";
})(ModelProfile || (ModelProfile = {}));
/**
 * Describes the enum vitesse.v1.ModelProfile.
 */
export const ModelProfileSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_model, 0);
/**
 * How an input binding names a PLC symbol (ModelDescriptor.symbol_paths).
 *
 * @generated from enum vitesse.v1.ModelSymbolPaths
 */
export var ModelSymbolPaths;
(function (ModelSymbolPaths) {
    /**
     * The subject token of the symbol: controllers/plc/symbols/DB10_Motor1_Speed.
     * Each descriptor saved before DISPLAY has this form.
     *
     * @generated from enum value: MODEL_SYMBOL_PATHS_ENCODED = 0;
     */
    ModelSymbolPaths[ModelSymbolPaths["ENCODED"] = 0] = "ENCODED";
    /**
     * The display path of the symbol: controllers/plc/symbols/DB10.Motor1.Speed.
     * symbols.search gives this form, and a PLC output always had it.
     *
     * @generated from enum value: MODEL_SYMBOL_PATHS_DISPLAY = 1;
     */
    ModelSymbolPaths[ModelSymbolPaths["DISPLAY"] = 1] = "DISPLAY";
})(ModelSymbolPaths || (ModelSymbolPaths = {}));
/**
 * Describes the enum vitesse.v1.ModelSymbolPaths.
 */
export const ModelSymbolPathsSchema = /*@__PURE__*/ enumDesc(file_vitesse_v1_model, 1);
/**
 * Browser-facing service. Bridged by api-gateway. api-gateway writes NO
 * `state.*` for models — every write verb forwards to the model-runner
 * (the sole owner of state.<gw>.models.<mid>); every read is a KV fanout.
 *
 * @generated from service vitesse.v1.Models
 */
export const Models = /*@__PURE__*/ serviceDesc(file_vitesse_v1_model, 0);
//# sourceMappingURL=model_pb.js.map